import { render, staticRenderFns } from "./MyCp4.vue?vue&type=template&id=19aa1a78&scoped=true&"
import script from "./MyCp4.vue?vue&type=script&lang=js&"
export * from "./MyCp4.vue?vue&type=script&lang=js&"
import style0 from "./MyCp4.vue?vue&type=style&index=0&id=19aa1a78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aa1a78",
  null
  
)

export default component.exports